import React from 'react';
import { Routes, Route } from "react-router-dom";
import Home from "./Common/Layout/Home";
import Register from './Authentication/Register';
import Login from './Authentication/Login';
import RecycleItems from './Components/Master/RecycleItems';
import PickupItems from './Components/Master/PickupItems';
import Branches from './Components/Master/Branches';
import Profile from './Authentication/Profile';
import ChangePassword from './Authentication/ChangePassword';
import AdminDashboard from './Dashboards/AdminDashboard';
import Users from './Components/Master/Users';
import Requests from './Components/Client/Requests';
import Collectors from './Components/Admin/Collectors';
import Buyers from './Components/Admin/Buyers';
import Clients from './Components/Admin/Clinets';
import AdminRequests from './Components/Admin/AdminRequests';
import CustomerProfile from './Authentication/CustomerProfile';
import Reports from './Components/Admin/Reports';
import ClientReport from './Components/Client/ClientReports';

function App() {
  return (
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
         <Route path="/register" element={<Register />} />
          <Route path="/recycleitems" element={<RecycleItems/>} />
          <Route path="/pickupitems" element={<PickupItems/>} />
          <Route path="/branches" element={<Branches/>} />
          <Route path="/profile" element={<Profile/>} />
          <Route path="/changepassword" element={<ChangePassword/>} />
          <Route path="/admin/dashboard" element={<AdminDashboard/>} />
          <Route path="/users" element={<Users/>} />
          <Route path="/customer/requests" element={<Requests/>} />
          <Route path="/clients" element={<Clients/>} />
          <Route path="/collectors" element={<Collectors/>} />
          <Route path="/buyers" element={<Buyers/>} />
          <Route path="/admin/requests" element={<AdminRequests/>} />
          <Route path="/customer/profile" element={<CustomerProfile/>} />
          <Route path="/reports" element={<Reports/>} />
          <Route path="/customer/reports" element={<ClientReport/>} />
          
      
        
          

    </Routes>
  );
}

export default App;